import {Inject, Injectable} from 'ng-metadata/core';
import {AddQueryToSavedSearchesService} from "../../search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service";

@Injectable()
export class TimeoutToastService {

    private _showTimeOutToastMessage: boolean = false;

    constructor(@Inject('$mdToast') private $mdToast: ng.material.IToastService,
                private addQueryToSavedSearchesService: AddQueryToSavedSearchesService){

    }

    public showTimeoutLogoutToast(){
        let templateString = '<prm-timeout-toast></prm-timeout-toast>';
        this.$mdToast.show({
            hideDelay   : 0,
            position    : 'top right',
            template : templateString
        }).then(()=>{
            this.addQueryToSavedSearchesService.onToastClose();
        });
    }

    get showTimeOutToastMessage() {
        return this._showTimeOutToastMessage;
    }

    set showTimeOutToastMessage(showTimeOutToastMessage) {
        this._showTimeOutToastMessage = showTimeOutToastMessage;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/timeoutToast/timeoutToast.service.ts